<template>
  <div class="suppliers-listing">
    <TolAlert v-if="tolAlert" v-bind="tolAlert" />
    <SuppliersFilters @change="onActiveInactiveChange" />
    <SuppliersActions />
    <tol-table
      :table-data="suppliers"
      :columns="columns"
      :is-row-clickable="true"
      @row-click="handleRowClick($event)"
    >
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortDirection"
          field-name="name"
          @change="onSortOrderChange"
          >{{ $t('suppliers.listing.labels.name') }}</th-sortable
        >

        <th>{{ $t('suppliers.listing.labels.defaultAddress') }}</th>

        <th>{{ $t('suppliers.listing.labels.heldCheque') }}</th>
      </template>

      <template v-slot:default_address="{ value }">
        <tol-address v-if="value.default_address" :address="value.default_address" />
      </template>
    </tol-table>

    <Pagination
      :records-per-page="SuppliersPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import {
  SuppliersListingGetters,
  SuppliersListingActions
} from '@/app/features/suppliers/features/suppliers-listing/suppliers-listing.keys';
import TolAlert from '@/app/components/TolAlert';
import { AppActions } from '@/app/app.keys';
import TolTable from '@/app/components/TolTable';
import ThSortable from '@/app/components/ThSortable';
import Pagination from '@/app/components/Pagination';
import TolAddress from '@/app/components/TolAddress';
import SuppliersFilters from '@/app/features/suppliers/features/suppliers-listing/components/SuppliersFilters';
import SuppliersActions from '@/app/features/suppliers/features/suppliers-listing/components/SuppliersActions';

export default {
  name: 'SuppliersListing',
  components: {
    TolTable,
    TolAlert,
    ThSortable,
    Pagination,
    TolAddress,
    SuppliersFilters,
    SuppliersActions
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    tolAlert() {
      return false;
    },
    suppliers() {
      return this.$store.getters[SuppliersListingGetters.SuppliersList];
    },
    SuppliersPerPage() {
      return this.$store.getters[SuppliersListingGetters.SuppliersPerPage];
    },
    currentPage() {
      return this.$store.getters[SuppliersListingGetters.SupplierListingOffset];
    },
    recordCount() {
      return this.$store.getters[SuppliersListingGetters.SuppliersRecordCount];
    },
    currentSortDirection() {
      return this.$store.getters[SuppliersListingGetters.SortDirection];
    },
    columns() {
      return ['name', 'default_address', 'client_name'];
    },
    activeInactive() {
      return this.$store.getters[SuppliersListingGetters.SuppliersActiveInactive];
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('suppliers.listing.title'));
    this.$store.dispatch(SuppliersListingActions.RetrieveSuppliersList);
  },
  methods: {
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(SuppliersListingActions.UpdateSuppliersSortOrder, sortOrder);
    },
    onChangePaginationParams(event) {
      this.$store.dispatch(SuppliersListingActions.UpdateSuppliersPaginationParameters, event);
    },
    onActiveInactiveChange(activeInactive) {
      this.$store.dispatch(SuppliersListingActions.UpdateSuppliersActiveInactive, activeInactive);
    },
    handleRowClick(evt) {
      this.$router.push(`/suppliers/${evt.reference_number}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.suppliers-listing {
  padding-left: 0;
}
</style>
